import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export function NotFoundPage(): ReactNode {
  return (
    <div className="grid min-h-dvh place-items-center bg-background px-4">
      <div className="max-w-md text-center">
        <p className="text-3xl font-bold text-primary">404</p>
        <h1 className="mt-2 text-base font-semibold text-content">Página no encontrada</h1>
        <p className="mt-1 text-sm text-muted">La dirección que abriste no existe.</p>
        <Link
          to="/"
          className="mt-5 inline-block rounded-card bg-primary px-4 py-2.5 text-sm font-medium text-white hover:bg-primary-hover"
        >
          Ir al inicio
        </Link>
      </div>
    </div>
  );
}
